module.exports = __webpack_public_path__ + "img/egg_braine.e0a233ad.png";